<div class="two-columns" *ngIf="certificationService.activeItem">
    <div>
        <div class="min-auto">
            <h1>Zertifizierung bearbeiten</h1>
        </div>
        <div class="auto-min">
            <mat-form-field>
                <input matInput placeholder="Hersteller" [value]="organisationService.activeItem.organisationName"
                    disabled />
            </mat-form-field>
        </div>
        <form #form="ngForm">
            <mat-form-field class="product-name"
                hintLabel="Keine schon vorhandenen Zertifizierungnamen oder Sonderzeichen">
                <input matInput placeholder="Name der Zertifizierung" [(ngModel)]="certificationEdit.name"
                    [(value)]="certificationEdit.name" required name="certificationName" #certificationName="ngModel" />
                <mat-error *ngIf="
                        certificationName.errors?.required &&
                        certificationName.touched
                    ">
                    Bitte geben Sie einen Zertifizierungsnamen ein.
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="Zertifizierungstyp" [value]="getCertificationType()" disabled />
            </mat-form-field>

            <mat-form-field *ngIf="!certificationEdit.issuerManaged" class="validity" hintLabel="Gültigkeit eines Zertifikats">
                <mat-select placeholder="Gültigkeit" [value]="fetchedCertification.validity"
                    (valueChange)="setCertificationValidity($event)" name="validity">
                    <mat-option [value]="1">1 Jahr</mat-option>
                    <mat-option [value]="2">2 Jahre</mat-option>
                    <mat-option [value]="3">3 Jahre</mat-option>
                    <mat-option [value]="4">4 Jahre</mat-option>
                    <mat-option [value]="5">5 Jahre</mat-option>
                </mat-select>
            </mat-form-field>
            <app-text-editor [(editorText)]="certificationEdit.description"
                (textValidityChange)="onDescriptionValidityChange($event)"></app-text-editor>
            <br />
            <mat-form-field *ngIf="!certificationEdit.issuerManaged" class="url">
                <input matInput placeholder="URL" [(ngModel)]="certificationEdit.url" [value]="fetchedCertification.url"
                    name="url" />
            </mat-form-field>

            <section *ngIf="certificationEdit.issuerManaged" class="issuer-schema-editor">
                <h2>JSON-Nodes</h2>
                <p>Die Nodes werden als JSON Schema in der Credential Definition und im Wallet gespeichert.</p>
                <app-certification-template-editor
                    [(shapeJson)]="certificationEdit.shape">
                </app-certification-template-editor>
            </section>

            <div class="auto-auto">
                <button mat-raised-button color="primary" [disabled]="form.invalid || !isDescriptionValid"
                    (click)="onSaveEdit()">
                    Speichern
                </button>
                <button mat-stroked-button color="accent" (click)="onCancelEdit()">
                    Abbrechen
                </button>
            </div>
        </form>
    </div>
    <div *ngIf="!certificationEdit.issuerManaged">
        <app-logo [fileId]="certificationEdit.fileId" (logoChanged)="certificationEdit.fileId = $event"></app-logo>
        <app-product-files [documentFileIds]="certificationEdit.documentFileIds"
            [galleryFileIds]="certificationEdit.galleryFileIds" [logoId]="certificationEdit.fileId"
            [galleryTitle]="'Zertifizierungsgalerie'"
            (logoChanged)="certificationEdit.fileId = $event"></app-product-files>
    </div>
</div>
